import { render, staticRenderFns } from "./BrainViz3.vue?vue&type=template&id=344369dc&scoped=true"
import script from "./BrainViz3.vue?vue&type=script&lang=js"
export * from "./BrainViz3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344369dc",
  null
  
)

export default component.exports